module.exports = __webpack_public_path__ + "assets/img/ce2158c783e56812baaf90afd2a37dce.svg";